import Vue from 'vue'
import { checkAccess } from './constant/_access'
import { mapGetters } from 'vuex'

Vue.mixin({
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    ...mapGetters({ authUser: 'auth/currentUser' }),
  },
  methods: {
    checkAccess(permission, data) {
      return checkAccess(permission, this.authUser, data)
    },
    checkAndEmit(event, data) {
      if (this.$listeners[event]) {
        this.$emit(event, data)
      }
    },
  },
})
